import React from 'react';

import {WidthItem} from 'src/components/width-item';

import {Cell} from '@pb/kit-component-data-table-v2';
import Icon, {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Tooltip} from '@pb/kit-component-popups';


import {mainColumnCell, mainColumnCellGroupRow, mainColumnCellLabel} from './main-column-cell.module.styl';

import type {CellOptions} from '@pb/kit-component-data-table-v2';

type Props = {
    children: React.ReactNode,
    selection: React.ReactNode,
    cellOptions: CellOptions,
    onExpand: () => void,
    onCollapse: () => void,
    isExpanded: boolean,
    isEmpty?: boolean,
};

export const MainColumnGroupCell: React.FC<Props> = props => {
    const {
        isEmpty,
        children,
        selection,
        cellOptions,
        onCollapse,
        onExpand,
        isExpanded,
    } = props;

    return (
        <Cell
            {...cellOptions}
            className={mainColumnCellGroupRow}>
            <div className={mainColumnCell}>
                <WidthItem width={25}>
                    {selection}
                </WidthItem>
                <WidthItem width={25}>
                    {isEmpty ? (
                        <Tooltip anchor={({anchorRef, getAnchorProps}) => (
                            <Icon ref={anchorRef} {...getAnchorProps()} type={Icons.ERROR}/>
                        )}>
                            Preset is empty
                        </Tooltip>
                    ) : (
                        <BasicIconButton
                            iconProps={{type: isExpanded ? Icons.ANGLE_UP : Icons.ANGLE_DOWN}}
                            onClick={isExpanded ? onCollapse : onExpand}
                        />
                    )}
                </WidthItem>
                <div className={mainColumnCellLabel}>
                    {children}
                </div>
            </div>
        </Cell>
    );
};
